// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"f3a7a8a3","81":"4a6e8730","315":"01c14d89","380":"359ab1f6","787":"e8bc4b68","815":"b82f3992"}[chunkId] + ".chunk.js";
};